import { AssetLinks } from '@assets/assets';
import { Error } from './Error';
import { Label } from './Label';

type FieldWrapperProps = {
  label?: string;
  rangeValue?: number;
  className?: string;
  children: React.ReactNode;
  errorMessage?: string | undefined;
  float?: boolean;
  isSelectFloat?: boolean;
  isPlaceholder?: boolean;
  onIconClick?: () => void;
  htmlFor?: string;
};

export type FieldWrapperPassThroughProps = Omit<FieldWrapperProps, 'className' | 'children'>;

export const FieldWrapper = (props: FieldWrapperProps) => {
  const { label, rangeValue, errorMessage, className, children, float, isSelectFloat, isPlaceholder, onIconClick, htmlFor } =
    props;

  const errorClassName = errorMessage && 'iLendingCDX-text-field--error';

  return (
    <div className={`iLendingCDX-text-field-container__float ${className}`}>
      {!float && (
        <span>
          <Label
            htmlFor={htmlFor}
            className={`${errorClassName}`}
          >
            {label} {rangeValue && <b>{rangeValue}</b>}
          </Label>
          {onIconClick && (
            <span
              className="iLendingCDX-info-button__text-input"
              onClick={onIconClick}
            >
              <img
                src={AssetLinks.info}
                alt="info-icon"
              />
            </span>
          )}
        </span>
      )}

      {children}

      {float && (
        <span
          className={`${
            !isSelectFloat && isPlaceholder ? 'iLendingCDX-custom-select-label__float' : 'iLendingCDX-input-label__float'
          }`}
        >
          <Label
            htmlFor={htmlFor}
            className={` ${!isSelectFloat && isPlaceholder && 'iLendingCDX-custom-select-label'} ${errorClassName}`}
          >
            {label}
          </Label>
          {onIconClick && (
            <span
              className="iLendingCDX-info-button__text-input"
              onClick={onIconClick}
            >
              <img
                src={AssetLinks.info}
                alt="info-icon"
              />
            </span>
          )}
        </span>
      )}
      <Error errorMessage={errorMessage} />
    </div>
  );
};
